import styled from 'styled-components'

interface DotStatusProps {
  $isAvailable: boolean
}

export const Title = styled.div.attrs({
  className: 'flex align-center text-12 text-semibold',
})`
  width: 30%;
  min-width: 130px;
  max-width: 200px;
`

export const Value = styled.div.attrs({
  className: 'flex-1 text-12 text-medium',
})``

export const DotStatus = styled.div<DotStatusProps>`
  background-color: ${({ theme, $isAvailable }) =>
    $isAvailable ? theme.colors.success : theme.colors.error};
  border-radius: 50%;
  width: 8px;
  height: 8px;
`
